const initialState = {
  loading: false
};

export function fetchWheelsExchangePlanning(state = initialState, action) {
  switch(action.type) {
    case 'FETCH_WHEELS_EXCHANGE_PLANNING.SUCCESS':
      return {
        ...state,
        planning: action.planning.body
      };
    default:
      return state;
  }
}

export function fetchTiresExchangePlanning(state = initialState, action) {
  switch(action.type) {
    case 'FETCH_TIRES_EXCHANGE_PLANNING.SUCCESS':
      return {
        ...state,
        planning: action.planning.body
      };
    default:
      return state;
  }
}

export function fetchWheelsExchangeSlots(state = initialState, action) {
  switch(action.type) {
    case 'FETCH_WHEELS_EXCHANGE_SLOTS.SUCCESS':
      return {
        ...state,
        slots: action.slots.body
      };
    default:
      return state;
  }
}

export function fetchTiresExchangeSlots(state = initialState, action) {
  switch(action.type) {
    case 'FETCH_TIRES_EXCHANGE_SLOTS.SUCCESS':
      return {
        ...state,
        slots: action.slots.body
      };
    default:
      return state;
  }
}

export function saveWheelsExchangeSlots(state = initialState, action) {
  switch(action.type) {
    case 'SAVE_WHEELS_EXCHANGE_SLOTS.SUCCESS':
      return {
        ...state,
        slots: action.slots.body
      };
    case 'SHOW_WHEELS_EXCHANGE_SLOT_ADD_MODAL':
      return {
        ...state,
        showAddModal: action.show,
      };
    case 'SHOW_WHEELS_EXCHANGE_SLOT_EDIT_MODAL':
      return {
        ...state,
        showEditModal: action.show,
      };
    default:
      return state;
  }
}

export function saveTiresExchangeSlots(state = initialState, action) {
  switch(action.type) {
    case 'SAVE_TIRES_EXCHANGE_SLOTS.SUCCESS':
      return {
        ...state,
        slots: action.slots.body
      };
    case 'SHOW_TIRES_EXCHANGE_SLOT_ADD_MODAL':
      return {
        ...state,
        showAddModal: action.show,
      };
    case 'SHOW_TIRES_EXCHANGE_SLOT_EDIT_MODAL':
      return {
        ...state,
        showEditModal: action.show,
      };
    default:
      return state;
  }
}

export function fetchSwitchExchangeWheelsSlots(state = initialState, action) {
  switch(action.type) {
    case 'FETCH_SWITCH_EXCHANGE_SLOTS.REQUEST':
      return {
        ...state,
        slots: []
      };
    case 'FETCH_SWITCH_EXCHANGE_SLOTS.SUCCESS':
      return {
        ...state,
        slots: action.slots.body
      };
    case 'SHOW_SWITCH_TIRES_SLOTS_MODAL':
      return {
        ...state,
        showSwitchTiresModal: action.show,
      };
    case 'SHOW_SWITCH_WHEELS_SLOTS_MODAL':
      return {
        ...state,
        showSwitchWheelsModal: action.show,
      };
    default:
      return {...state};
  }
}



// WEBPACK FOOTER //
// ./src/reducers/WheelsExchangePlanning.js